<template>
  <div class="copyright">
      {{`©1998-${year} 弘成科技发展有限公司 版权所有`}}
  </div>
</template>

<script>
export default {
    name: 'copyright',
    data () {
        return {
            year: new Date().getFullYear()
        }
    }
}
</script>

<style>
.copyright {
    font-size: 14px;
    color: #9299A6;
    text-align: center;
    margin-top: 20px;
}
</style>